import { Grid, Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 0,
    borderRadius: 2,
  },
}));

const SaveEventOverlay = ({
  saveEventOpen,
  setSaveEventOpen,
  saveEvent,
  locations,
  placeholders,
  template = {},
}) => {
  const classes = useStyles();

  const getDate = (date) => {
    if (date) {
      if (date instanceof Date) return date;

      return date.toDate();
    }

    return new Date();
  };

  const [values, setValues] = useState({
    numberOfPeople: template.numberOfPeople || 50,
    radius: template.radius || 50,
    eventName: template.eventName || "",
    nameOfEvent: template.nameOfEvent || "",
    eventNameHelperText: "",
    endTimeHelperText: "",
    startLocationHelperText: "",
    locationAddress: template.locationAddress || "",
    startTime: getDate(template.startTime),
    endTime: getDate(template.endTime),
  });

  useEffect(() => {
    setValues({
      ...values,
      eventName: template.eventName || "",
      radius: template.radius || 50,
      locationAddress: template.locationAddress || "",
      numberOfPeople: template.numberOfPeople || 50,
      startTime: getDate(template.startTime),
      endTime: getDate(template.endTime),
    });
  }, [JSON.stringify(template)]);

  const handleChange = (prop) => (event) => {
    if (prop.toLowerCase().includes("date")) {
      setValues({
        ...values,
        startTime: event,
        endTime: event,
        endTimeHelperText: "",
      });
    } else if (prop.toLowerCase().includes("time")) {
      setValues({ ...values, endTimeHelperText: "", [prop]: event });
    } else {
      setValues({
        ...values,
        eventNameHelperText: "",
        endTimeHelperText: "",
        startLocationHelperText: "",
        [prop]: event.target.value,
      });
    }
  };

  return (
    <Modal
      className={classes.modal}
      open={saveEventOpen}
      onClose={() => setSaveEventOpen(false)}
    >
      <Fade in={saveEventOpen}>
        <Grid xs={6} item className={classes.paper}>
          <Typography variant="h5" gutterBottom>
            Finalize Event
          </Typography>
          <Divider style={{ marginBottom: 20, marginTop: 20 }} />
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <TextField
                value={values.nameOfEvent}
                onChange={handleChange("nameOfEvent")}
                fullWidth
                label="Event Name"
              />
            </Grid>
            <Grid item>
              <TextField
                value={values.eventName}
                onChange={handleChange("eventName")}
                fullWidth
                label="Name of closest city (or village), e.g. Zürich"
                helperText={values.eventNameHelperText}
                error={values.eventNameHelperText.length > 0}
              />
            </Grid>
            <Grid item>
              <TextField
                value={values.numberOfPeople}
                onChange={handleChange("numberOfPeople")}
                fullWidth
                type="number"
                id="standard-basic1"
                label="How many people do you expect to join?"
              />
            </Grid>
            <Grid item>
              <TextField
                value={values.locationAddress}
                onChange={handleChange("locationAddress")}
                fullWidth
                label="Start Address"
                helperText={values.startLocationHelperText}
                error={values.startLocationHelperText.length > 0}
              />
            </Grid>
            <Grid item>
              <TextField
                value={values.radius}
                onChange={handleChange("radius")}
                fullWidth
                label="Radius"
                type="number"
              />
            </Grid>
            <Grid item>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  fullWidth
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker-inline"
                  label="Start Date"
                  value={values.startTime}
                  onChange={handleChange("startDate")}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
                <KeyboardTimePicker
                  fullWidth
                  margin="normal"
                  ampm={false}
                  label="Start Time"
                  value={values.startTime}
                  onChange={handleChange("startTime")}
                  KeyboardButtonProps={{
                    "aria-label": "change time",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid container>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  if (values.eventName.length === 0) {
                    return setValues({
                      ...values,
                      eventNameHelperText: "This field is required",
                    });
                  }
                  if (values.locationAddress.length === 0) {
                    return setValues({
                      ...values,
                      startLocationHelperText: "This field is required",
                    });
                  }

                  try {
                    saveEvent(template, locations, placeholders, {
                      startTime: values.startTime,
                      endTime: values.endTime,
                      numberOfPeople: parseInt(values.numberOfPeople),
                      locationAddress: values.locationAddress,
                      eventName: values.eventName,
                      nameOfEvent: values.nameOfEvent,
                      radius: parseInt(values.radius),
                    });
                  } catch (e) {
                    console.log(e);
                  }
                }}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Fade>
    </Modal>
  );
};

export default SaveEventOverlay;

SaveEventOverlay.defaultProps = {
  template: {},
  saveEventOpen: false,
};

SaveEventOverlay.propTypes = {
  setSaveEventOpen: PropTypes.func.isRequired,
};
